import { CommonError } from '@/types/base';
import { Address, AppConfigByCountry, AppUserInfo, ConfigByCountry } from '@/types/user';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
interface AppState {
  initialed: boolean;
  commonError: CommonError[];
  isAnonymous: boolean;
  userInfo: Partial<AppUserInfo>;
  billToInfo: Partial<Address>;
  shipToList?: Address[];
  userInvoiceEmails?: any;
  configByCountry: AppConfigByCountry;
  setInitialed: (initialed: boolean) => void;
  setShipBillInfo: (billToInfo, shipToList, userInvoiceEmails) => void;
  setUserInfo: (userInfo: AppUserInfo) => void;
  setIsAnonymous: (isAnonymous: boolean) => void;
  addCommonError: (languageKey: string, arg?: { [key: string]: string }) => void;
  removeCommonError: (languageKey: string) => void;
  clearCommonError: () => void;
  setConfigByCountry: (configByCountry: AppConfigByCountry) => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    immer((set) => ({
      configByCountry: null,
      initialed: false,
      billToInfo: {},
      shipToList: null,
      setShipBillInfo: (billToInfo, shipToList, userInvoiceEmails) =>
        set({ shipToList, billToInfo, userInvoiceEmails }),
      userInfo: {},
      setUserInfo: (userInfo) => {
        set({ userInfo });
      },
      setInitialed: (initialed) => set({ initialed }),
      isAnonymous: true,
      setIsAnonymous: (isAnonymous) => set({ isAnonymous }),
      commonError: [],
      addCommonError: (languageKey: string, arg: { [key: string]: string }) => {
        set((state) => {
          if (state.commonError.some((error) => error?.languageKey === languageKey)) return;
          state.commonError.push({ languageKey, arg });
        });
      },
      removeCommonError: (languageKey: string) => {
        set((state) => {
          state.commonError = state.commonError.filter((error) => error.languageKey !== languageKey);
        });
      },
      clearCommonError: () => {
        set((state) => {
          state.commonError = [];
        });
      },
      setConfigByCountry: (configByCountry) => set({ configByCountry }),
    })),
    {
      name: 'global-app-store',
    }
  )
);
